import {
  Building2,
  Flag,
  GraduationCap,
  School,
  Sparkles,
  Ticket,
  type LucideIcon,
} from 'lucide-react';
import type { ActivityCategory } from '@/types/gamePlanTracker';

// Per-activity-type presentation for the logged-activity stream. Icons use the
// brand palette as punctuation (gold for outreach/community, forest for
// business/venue) — not loud per-type colors, staying within the one-strong-
// color-per-screen rule. `tint` is a low-opacity chip background.
export interface ActivityTypeStyle {
  label: string;
  Icon: LucideIcon;
  tint: string;
  accent: string;
}

export const ACTIVITY_TYPES: Record<ActivityCategory, ActivityTypeStyle> = {
  corporate: {
    label: 'Corporate',
    Icon: Building2,
    tint: 'rgba(12,61,45,0.08)',
    accent: 'var(--color-forest)',
  },
  hs: {
    label: 'High School',
    Icon: GraduationCap,
    tint: 'rgba(181,143,45,0.16)',
    accent: 'var(--color-text-gold)',
  },
  college: {
    label: 'College',
    Icon: School,
    tint: 'rgba(124,98,32,0.14)',
    accent: 'var(--color-text-gold)',
  },
  golf: {
    label: 'Golf Course',
    Icon: Flag,
    tint: 'rgba(12,61,45,0.06)',
    accent: 'var(--color-forest)',
  },
  event: {
    label: 'Event',
    Icon: Ticket,
    tint: 'rgba(181,143,45,0.16)',
    accent: 'var(--color-text-gold)',
  },
  other: {
    label: 'Other',
    Icon: Sparkles,
    tint: 'rgba(22,36,30,0.06)',
    accent: 'var(--text-content-sub-title)',
  },
};

// "2026-10-29" → "Oct 29"
export function shortDate(iso?: string): string {
  if (!iso) return '';
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return '';
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
  ];
  return `${months[m - 1]} ${d}`;
}
